import * as angular from 'angular';
import CompanySelect from "./CompanySelect";
import CustomerPaymentProfileSelect from "./CustomerPaymentProfileSelect";
import CustomerSelect from "./CustomerSelect";
import QbClassSelect from "./QbClassSelect";
import QbCustomerMsgSelect from "./QbCustomerMsgSelect";
import QbCustomerSearch from "./QbCustomerSearch";
import QbItemSearch from "./QbItemSearch";
import QbSalesRepSelect from "./QbSalesRepSelect";
import QbTemplateSelect from "./QbTemplateSelect";
import QbTermsSelect from "./QbTermsSelect";
import TextBox from "./TextBox";
import QbPriceLevelSelect from "./QbPriceLevelSelect";
import QbItemSalesTaxSelect from "./QbItemSalesTaxSelect";
import QbSalesTaxCodeSelect from "./QbSalesTaxCodeSelect";
import QbPending from "./QbPending";
import InputPhone from "./InputPhone";
import CustomerSearchTable from "./CustomerSearchTable";
import QbTransactionHistory from "./QbTransactionHistory";
import TxnViewBtn from "./TxnViewBtn";
import ContactList from "./ContactList";
import ContactListTable from "./ContactListTable";
import ContactEditComponent from "./ContactEditComponent";
import LeadSourceSelect from "./ContactSelect";
import LeadStatusSelect from "./LeadStatusSelect";
import ActivityTable from "./ActivityTable";
import UserSelect from "./UserSelect";
import ContactSelect from "./ContactSelect";
import ActivityTypeSelect from "./ActivityTypeSelect";
import RecordAuditWidget from "./RecordAuditWidget";
import MenuBar from "./MenuBar"



export default angular.module('app.components', [
    CompanySelect,
    CustomerPaymentProfileSelect,
    CustomerSelect,
    CustomerSearchTable,
    InputPhone,
    QbClassSelect,
    QbCustomerMsgSelect,
    QbCustomerSearch,
    QbItemSearch,
    QbItemSalesTaxSelect,
    QbPending,
    QbPriceLevelSelect,
    QbSalesRepSelect,
    QbSalesTaxCodeSelect,
    QbTemplateSelect,
    QbTermsSelect,
    QbTransactionHistory,
    TextBox,
    TxnViewBtn,
    ContactList,
    ContactListTable,
    ContactEditComponent,
    LeadSourceSelect,
    LeadStatusSelect,
    ActivityTable,
    UserSelect,
    ContactSelect,
    ActivityTypeSelect,
    RecordAuditWidget,
    MenuBar
])
    .name;
